import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import TimeBlockForm from './TimeBlockForm';

// Rename the name of the function:
const TimeBlockList: React.FC = () => {

    // Specify the options of this list:
    const query = {
        endpoint: 'get_timeblock_list',
        defaultParams: { 'deleted': false },
        object: 'timeblock'
    }
    const objectName = 'timeblock.general.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deleted'
    
    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <TimeBlockForm />;
    const onRowClick = 'editModal'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'name', label: 'timeblock.general.name_label' },
    ];

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
        />
    );
};

export default TimeBlockList;